import axios from 'axios';
import config from "../config.js";
//import router from "../routeur.js"
//import store from "../store.js"
export default class RequestManager {
    // Initialise le token depuis localStorage des le chargement du module.
    // Necessaire car router.beforeEach s'execute AVANT App.vue.created() (qui
    // appelle setToken) : dans un nouvel onglet (window.open '_blank' de
    // lancerLots), sans cette valeur connexionWithToken partirait sans en-tete
    // Authorization -> 401 -> deconnexion -> redirection Accueil.
    static token = localStorage.getItem("Token") || "";
    static estMobile = true;
    static avecWebView = false;
    static instance = axios.create({
        baseURL: config.urlBackEnd,
        timeout: 90000,
        headers: {
            'Authorization': this.getToken(),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    });
    static getDefaultConfig() {
        return {
            headers: {
                'Authorization': this.getToken(),
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }
    }
    static setConfig(config) {
        this.config = config;
    }
    static getConfig() {
        return this.config;
    }
    static getToken() {
        //alert("getToken() " + this.token);
        return this.token ? 'Bearer ' + this.token : null;
    }

    static setToken(token) {
        this.token = token;
        this.instance.defaults.headers.common['Authorization'] = this.getToken();
        localStorage.setItem("Token", token);
    }

    static async get(url) {
        return await this.instance.get(url, this.getDefaultConfig())
            .then(response => { return response.data })
            .catch(error => console.error(error));
    }

    // Comme get() mais NE masque PAS l'erreur (l'appelant la gere) : utile pour
    // distinguer "backend injoignable" d'une reponse vide.
    static async getStrict(url) {
        return await this.instance.get(url, this.getDefaultConfig())
            .then(response => { return response.data });
    }

    // Traduit une erreur axios en message lisible, sans divulguer d'info sensible.
    // Distingue : backend a repondu une erreur HTTP / backend injoignable / autre.
    static decrireErreur(error) {
        if (error && error.response) {
            return `Le serveur a renvoyé une erreur (HTTP ${error.response.status}).`;
        }
        if (error && (error.request || error.code === 'ECONNABORTED')) {
            return "BackEndParent injoignable (réseau ou VPN ?).";
        }
        return "Erreur inattendue" + (error && error.message ? " : " + error.message : "") + ".";
    }

    static async post(url, data, signal) {
        return await this.instance.post(url, data, { ...this.getDefaultConfig(), signal })
            .then(response => { return response.data })
            .catch(error => {
                if (axios.isCancel(error)) {
                    console.warn("Requête annulée :", error.message);
                } else {
                    console.error("Erreur lors de la requête :", error);
                }
                throw error;
            });
    }

    static async put(url, data) {
        return await this.instance.put(url, data, this.getDefaultConfig())
            .then(response => { return response.data })
            .catch(error => console.error(error));
    }

    static async delete(url) {
        return this.instance.delete(url, this.getDefaultConfig())
            .then(response => { return response.data })
            .catch(error => console.error(error));
    }

    static checkError() {
        //this.instance.interceptors.response.use(
        //    function (response) {
        //        console.log(response);
        //        return response;
        //    },
        //    function (error) {
        //        console.log(error.response)
        //        alert("Erreur");
        //        if (error.response && error.response.status === 401) {
        //            console.log(store);
        //            router.push('/');
        //        }
        //        return Promise.reject(error);
        //    }
        //);
    }

    static EnvoyerMessageWebView(functionCall) {
        if (this.avecWebView) {
            if (this.estMobile) {
                //InvokeDisplayJSText(functionCall);
                //alert('EnvoyerMessageWebView mobile');
                postMessageWebView(JSON.stringify(functionCall));
            }
            else {
                //alert('EnvoyerMessageWebView postMessage');
                chrome.webview.postMessage(functionCall);
                //alert('EnvoyerMessageWebView apres postMessage');
            }
        }
    }
}

